<template>
  <el-dialog title="叫号" :visible.sync="visible" width="740px" :close-on-click-modal="false">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="车辆业务类型" prop="car_business_id">
        <tableSelector v-model="form.car_business_id" :multiple="false" title="选择车辆业务类型"
                       :rows.sync="form.car_business"
                       url="/api/queue/admin/query_business" :params="car_business_params" :columns="[
            { label: '车辆代码', prop: 'code' },
            { label: '车辆预约业务类型', prop: 'name' }
          ]">
          <div class="mb-4" slot="search">
            <span>关键字：</span>
            <el-input clearable class="w-60" v-model="car_business_params.keyword"
                      placeholder="输入关键字搜索"></el-input>
          </div>
          <template slot="content">
            <div>
              <div v-for="item in form.car_business" :key="item.id">
                {{ item.name }}
              </div>
            </div>
          </template>
          <el-link type="primary" :underline="false">选择</el-link>
        </tableSelector>
      </el-form-item>
      <el-form-item v-if="form.car_business_id" label="查看分配比例">
        <el-popover placement="right-start" width="520" trigger="click">
          <div>
            <c-table class="w-full" :data="detail" :columns="columns" :showPagination="false">
            </c-table>
          </div>
          <c-link slot="reference" type="primary" label="查看"></c-link>
        </el-popover>
      </el-form-item>
      <el-form-item v-if="shouldShowVehicleType" label="车辆类型" prop="vehicle_type">
        <el-select class="w-96" clearable v-model="form.vehicle_type" placeholder="请选择车辆类型">
          <el-option v-for="car in vehicleTypes" :key="car.id" :label="car.name" :value="car.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="在装卸数量">
        <span class="text-yellow-600">{{ form.wait_unload_num }}</span>
      </el-form-item>
      <el-form-item label="待叫号数量">
        <span class="text-red-600">{{ form.wait_calling_num }}</span>
      </el-form-item>
      <el-form-item label="装卸点空位">
        <span :class="form.has_effective_warehouse_point ? 'text-green-600' : 'text-gray-500'">
          {{ unloadSlotText }}
        </span>
      </el-form-item>
      <el-form-item label="叫号数量" prop="limit">
        <el-input-number placeholder="请输入叫号数量" class="inputNumber w-96" :step="1"
                         step-strictly v-model="form.limit" controls-position="right" :min="0" :max="callMax"
                         :controls="false"></el-input-number>
      </el-form-item>
      <el-form-item label="指定进厂门岗" prop="in_door_ids">
        <el-select multiple class="w-96" v-model="form.in_door_ids" placeholder="请选择指定进厂门岗">
          <el-option v-for="item in doors" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="submitting" @click="onCancel">取 消</el-button>
      <el-button type="primary" :loading="submitting" :disabled="submitting" @click="onConfirm">确认叫号</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {mapGetters} from "vuex";
import tableSelector from "@/components/tableSelector/index.vue";

export default {
  data() {
    return {
      visible: false,
      submitting: false,
      form: {
        car_business_id: [],
        car_business: [],
        vehicle_type: undefined,
        wait_unload_num: 0,
        wait_calling_num: 0,
        available_calling_num: 0,
        has_effective_warehouse_point: false,
        limit: undefined,
        in_door_ids: []
      },
      detail: [],
      car_business_params: {
        is_parent: 1,
        state: 1,
        keyword: ''
      },
      // 显式维护提货业务类型常量，避免模板和监听器里散落魔法值。
      pickupBusinessType: 12,
      rules: {
        car_business_id: [
          {
            required: true,
            message: "请选择车辆业务类型",
            trigger: "change",
            type: "array"
          }
        ],
        limit: [{required: true, message: "请输入叫号数量", trigger: "blur"}]
      },
      columns: [
        {label: "装卸点", prop: "warehouse_name"},
        {label: "仅装卸比例", prop: "unload_ratio"},
        {label: "装卸+取样比例", prop: "sampling_unload_ratio"}
      ],
      doors: [],
    };
  },
  computed: {
    ...mapGetters(["businessState", "vehicleTypes"]),
    // 根据选中的车辆业务类型判断是否属于提货业务，供界面显隐和联动清空复用。
    selectedCarBusinessType() {
      const [selectedBusiness] = this.form.car_business || [];
      return Number(selectedBusiness && selectedBusiness.type) || undefined;
    },
    // 提货业务不需要再按车辆类型细分叫号，因此直接隐藏车辆类型选择项。
    shouldShowVehicleType() {
      return this.selectedCarBusinessType !== this.pickupBusinessType;
    },
    callMax() {
      if (!this.form.wait_calling_num) {
        return undefined;
      }
      return this.form.wait_calling_num > 10 ? 10 : this.form.wait_calling_num
    },
    unloadSlotText() {
      return this.form.has_effective_warehouse_point ? this.form.available_calling_num : "未配置装卸点";
    }
  },
  created() {
    this.getDoors();
  },
  watch: {
    "form.car_business_id": async function (val) {
      const car_business_id = String(val);
      if (car_business_id) {
        this.getCount();
        const dataObj = await this.$common.http({
          url: "/api/queue/dispatcher/query_warehouse_by_business_id",
          data: {
            car_business_id
          }
        });
        this.detail = dataObj.data.data;
      } else {
        this.$set(this.form, "wait_unload_num", 0);
        this.$set(this.form, "wait_calling_num", 0);
        this.$set(this.form, "available_calling_num", 0);
        this.$set(this.form, "has_effective_warehouse_point", false);
        this.detail = [];
      }
      this.form.limit = undefined;
    },
    "form.vehicle_type": function (val) {
      // 提货业务隐藏车辆类型后仍需按车辆业务类型统计数量，不能把计数误清零。
      if (this.form.car_business_id && (val || !this.shouldShowVehicleType)) {
        this.getCount();
      } else {
        this.$set(this.form, "wait_unload_num", 0);
        this.$set(this.form, "wait_calling_num", 0);
        this.$set(this.form, "available_calling_num", 0);
        this.$set(this.form, "has_effective_warehouse_point", false);
      }
      this.form.limit = undefined;
    },
    selectedCarBusinessType: function (val) {
      // 关键步骤：切换到提货业务时清空旧的车辆类型，避免隐藏字段残留历史值参与叫号。
      if (val === this.pickupBusinessType && this.form.vehicle_type !== undefined) {
        this.form.vehicle_type = undefined;
      }
    }
  },
  components: {
    tableSelector
  },
  methods: {
    // 打开叫号弹窗，沿用组件内已有状态并展示表单。
    show() {
      this.visible = true;
    },
    // 根据当前车辆业务类型和车辆类型统计在装卸与待叫号数量。
    async getCount() {
      const res = await this.$common.http({
        url: "/api/queue/admin/count_auth_booking",
        data: {
          car_business_id: String(this.form.car_business_id),
          vehicle_type: this.form.vehicle_type
        }
      });
      const {wait_unload_num, wait_calling_num, available_calling_num, has_effective_warehouse_point} = res.data.data;
      this.$set(this.form, "wait_unload_num", wait_unload_num);
      this.$set(this.form, "wait_calling_num", wait_calling_num);
      this.$set(this.form, "available_calling_num", available_calling_num || 0);
      this.$set(this.form, "has_effective_warehouse_point", !!has_effective_warehouse_point);
    },
    // 校验并提交叫号请求，保持提货业务隐藏字段时不传入无效车辆类型。
    onConfirm() {
      this.$refs.form.validate(async valid => {
        if (!valid || this.submitting) {
          return false;
        }
        this.submitting = true;
        try {
          const {car_business_id, vehicle_type, limit, in_door_ids} = this.form;
          const res = await this.$common.http({
            url: "/api/queue/admin/call_booking",
            data: {
              vehicle_type,
              limit,
              car_business_id: String(car_business_id),
              in_door_ids: in_door_ids
            }
          });
          this.$emit("ok", res.data.data);
          this.onCancel();
        } finally {
          this.submitting = false;
        }
      });
    },
    // 关闭弹窗时统一重置表单，避免上一次选择残留到下一次叫号。
    onCancel() {
      this.form = {
        car_business_id: [],
        car_business: [],
        vehicle_type: undefined,
        wait_unload_num: 0,
        wait_calling_num: 0,
        available_calling_num: 0,
        has_effective_warehouse_point: false,
        limit: undefined,
        in_door_ids: []
      };
      this.submitting = false;
      this.visible = false;
    },
    // 加载可指定的进厂门岗列表，供叫号时按门岗限流使用。
    getDoors() {
      this.$common.http({
        url: '/api/queue/admin/query_door',
        data: {state: 1, keyword: "", page_size: 999}
      }).then((res) => {
        this.doors = res.data.data.data;
      })
    },
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";

.inputNumber {
  /deep/ .el-input__inner {
    text-align: left !important;
  }
}

/deep/ .el-input__validateIcon {
  display: none;
}
</style>
